export const monumentActionTypes = {
  LOAD_MONUMENTS: 'LOAD_MONUMENTS'
};
